exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.editing-box {\n  box-sizing: border-box;\n  background-color: white;\n  border-style: dotted;\n  border-color: #ffd500;\n  position: absolute;\n  z-index: 999;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5d5deb2a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/EditingBox.vue
// module id = 524
// module chunks = 0